import { type VariantProps } from "class-variance-authority"
import React, {
  PropsWithChildren,
  ReactNode,
  forwardRef,
  type HTMLAttributes,
  type InputHTMLAttributes,
} from "react"

import { cn } from "../../helpers"
import * as styles from "./input.styled"

export type InputProps = InputHTMLAttributes<HTMLInputElement> &
  VariantProps<(typeof styles)["inputVariants"]> & {
    RightIcon?: ReactNode
    LeftIcon?: ReactNode
  }

const Input = forwardRef<HTMLInputElement, InputProps>(
  (
    { className, type, size, variant, RightIcon, LeftIcon, disabled, ...props },
    ref
  ) => {
    return (
      <label
        className={cn(
          styles.inputVariants({ size, variant, disabled, className })
        )}
      >
        {RightIcon ? RightIcon : null}
        <input
          className={styles.basicInput}
          type={type}
          ref={ref}
          {...props}
          disabled={disabled}
        />
        {LeftIcon ? LeftIcon : null}
      </label>
    )
  }
)
Input.displayName = "Input"

const InputWrapper = ({
  children,
  className,
  ...props
}: PropsWithChildren<HTMLAttributes<HTMLDivElement>>) => {
  return (
    <div className={styles.wrapper(className)} {...props}>
      {children}
    </div>
  )
}

export { Input, InputWrapper }
